export default {
  Clients: state => state.Clients,
  SelectedClientEdit: state => state.SelectedClientEdit,
  ClientView: state => state.ClientView,
  Pedidos: state => state.Pedidos,
  PedidoView: state => state.PedidoView,
  PaymentBrick: state => state.PaymentBrick,
  PaymentStatus: state => state.PaymentStatus,
  PedidoAtual: state => state.PedidoAtual,
  TryAgainPay: state => state.TryAgainPay,
  cupom: state => state.cupom,
  ClientValidate: state => state.ClientValidate,
  EditClientValidate: state => state.EditClientValidate,
  LoadPay: state => state.LoadPay,
  ValorFrete: state => state.ValorFrete,
  NotasPedido: state => state.NotasPedido,
  PixApproved: state => state.PixApproved
}
